import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';
import { NgClass } from '@angular/common';
import { TimeAgoPipe } from '../../pipes/time-ago.pipe';


@Component({
    selector: '[notification-toast-component]',
    styles: [],
    template: `
  <div class="toast {{state() === 'inactive' ? '' : 'show'}}" role="alert" aria-live="assertive" aria-atomic="true" [style.display]="state() === 'inactive' ? 'none' : ''">
    @if (title()) {
      <div class="toast-header">
        <strong class="me-auto" [ngClass]="options().titleClass" [attr.aria-label]="title()">{{ title() }}</strong>
        @if (options().payload?.created_at) {
          <small>{{options().payload?.created_at | timeAgo}}</small>
        }
        @if (options().closeButton) {
          <button (click)="remove()" type="button" class="ms-2 mb-1 close" data-bs-dismiss="toast" aria-label="Chiudi notifica">
            <span aria-hidden="true">&times;</span>
          </button>
        }
      </div>
    }
    @if (message() && options().enableHtml) {
      <div class="toast-body" role="alert"
        [class]="options().messageClass" [innerHTML]="message()">
      </div>
    }
    @if (message() && !options().enableHtml) {
      <div class="toast-body" role="alert"
        [class]="options().messageClass" [attr.aria-label]="message()">
        {{ message() }}
      </div>
    }
    @if (options().progressBar) {
      <div>
        <div class="toast-progress" [style.width]="width() + '%'"></div>
      </div>
    }
  </div>
  `,
    animations: [
        trigger('flyInOut', [
            state('active', style({
                opacity: 1,
            })),
            transition('inactive => active', animate('400ms ease-out', keyframes([
                style({
                    transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
                    opacity: 0,
                }),
                style({
                    transform: 'skewX(20deg)',
                    opacity: 1,
                }),
                style({
                    transform: 'skewX(-5deg)',
                    opacity: 1,
                }),
                style({
                    transform: 'none',
                    opacity: 1,
                }),
            ]))),
            transition('active => removed', animate('400ms ease-out', keyframes([
                style({
                    opacity: 1,
                }),
                style({
                    transform: 'translate3d(100%, 0, 0) skewX(30deg)',
                    opacity: 0,
                }),
            ]))),
        ]),
    ],
    preserveWhitespaces: false,
    imports: [NgClass, TimeAgoPipe]
})
export class NotificationToastComponent extends Toast {
}
